import * as o from "react";
import a from "../lib/IconBase.es.js";
import n from "../defs/CaretDown.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: n }));
e.displayName = "CaretDownIcon";
const s = e;
export {
  s as CaretDown,
  e as CaretDownIcon
};
